import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function CTA() {
    return (
        <section className="relative py-24 lg:py-36 border-t border-navy/10 overflow-hidden" data-testid="cta-section">
            <div className="absolute inset-0 bg-grid opacity-30"></div>
            <div className="relative max-w-[1500px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
                    <div className="lg:col-span-8">
                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.9 }}
                            className="flex items-center gap-4 mb-8"
                        >
                            <div className="w-10 h-px bg-gold"></div>
                            <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">The Next Step</span>
                        </motion.div>

                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.9, delay: 0.1 }}
                            className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-[-0.03em]"
                        >
                            Get carbon risk <em className="text-gold not-italic font-light">off your P&amp;L</em> — while there is still time.
                        </motion.h2>
                    </div>

                    <div className="lg:col-span-4 lg:pb-6 flex flex-col gap-4 lg:items-end">
                        <Link to="/contact" className="btn-institution" data-testid="final-cta-primary">
                            Book a Briefing <ArrowUpRight size={14} />
                        </Link>
                        <a href="https://platform.carbonis.in" target="_blank" rel="noopener noreferrer" className="btn-ghost" data-testid="final-cta-secondary">
                            Tour the Platform <ArrowUpRight size={14} />
                        </a>
                    </div>
                </div>

                <div className="hairline mt-24"></div>

                <div className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-6 font-mono text-[10px] tracking-[0.22em] uppercase text-navy/50">
                    <div><span className="text-gold">→</span> Identify</div>
                    <div><span className="text-gold">→</span> Quantify</div>
                    <div><span className="text-gold">→</span> Mitigate</div>
                    <div><span className="text-gold">→</span> Protect</div>
                </div>
            </div>
        </section>
    );
}
